export const getCurrentLeadIdToken = (): string => {
  const leadIdTokenElement = document.getElementById('leadid_token');
  return leadIdTokenElement instanceof HTMLInputElement
    ? leadIdTokenElement.value
    : '';
};

// Creates a new Journaya tracking session and refreshes the leadId token
export const refreshLeadIdToken = () => {
  window.LeadiD?.reInit?.();
};
